<template>
    <div id="error-page">
        <van-image :src="errUrl" />
        <div class="title" v-if="title">{{ title }}</div>
        <div class="info" v-if="info">{{ info }}</div>
        <div>
            <van-button @click="returnRrl" plain hairline round type="primary">返回</van-button>
        </div>
    </div>
</template>

<script>
import { 
    Image, 
    Button
} from 'vant'
import { WxAssertBasicUrl } from '@/api/assert'
// import { getRouteParams, getRouteQuery } from '@/utils/usePage'
export default {
    components: {
        [Image.name]: Image,
        [Button.name]: Button
    },
    computed: {
        errUrl() {
            let url = WxAssertBasicUrl
            let errStyle = (this.style==null ? 1 : this.style)
            switch (errStyle) {
                case 1:
                    url = url + 'wx_error1.png'
                    break
                case 2:
                    url = url + 'wx_error2.png'
                    break
                default:
                    url = url + 'wx_error1.png'
                    break
            }
            return url
        }
    },
    data() {
        return {
            title: null,
            info: null,
            backUrl: null,
        }
    },
    mounted() {
        this.title = (this.$route.query.title? this.$route.query.title: null)
        this.info = (this.$route.query.info? this.$route.query.info: null)
        this.backUrl = (this.$route.query.backurl? this.$route.query.backurl: null)
    },
    methods: {
        returnRrl() {
            if (this.backUrl) {
                this.$router.push(this.backUrl)
            } else {
                this.$router.push('/home/')
            }
        }
    },
}
</script>

<style lang="less" scoped>
#error-page {
    text-align: center;
    padding-top: 50px;

    img {
        margin-top: 10em;
        width: 36%;
    }
    .title {
        margin-top: 4em;
        font-size: 1.2em;
        font-weight: bold;
    }
    .info {
        margin-top: 4em;
    }
    .van-button {
        margin-top: 4em;
    }
}
</style>